import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import styles
import CategoryList from './CategoryList';
// import AdminImg from '../../Img/usrpict.PNG';
import AdminImg from '../../Img/viewer.png';
import Viewer from '../../Img/viewer.png'
// import campraImg from "../../Img/LOGORepository.png"
import campraImg from "../../Img/logo.png"
import { useNavigate } from 'react-router';
import back from '../../Img/new home.png'
import InputData from '../EditInput.json'
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_BASE_URL } from "../../utils/config";
const EditPostPage = () => {
  const apiEndpoint = `${API_BASE_URL} /wp-json/wp/v2/posts`;
  let bearerToken = localStorage.getItem('jwt_token');
  const config = {


    headers: {
      'Authorization': `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',

    }

  };
  console.log("editInput=", InputData.InputValue);
  const [postData, setPostData] = useState({
    title: '',
    content: '',
    status: "publish"
  });
  const [content, setContent] = useState(`<h2 className='fw-bold'><strong> Problem Statement</strong></h2>
  <br/>
  <p>
    It’s no secret the coronavirus and recent Geo-Political Risks
    has completely shaken up life as we know it. It has affected
    people, businesses. 
  </p>
  <p>
    Scenario Analysis & Drawbacks of Conventional Scenario Analysis
    Scenario Analysis helps to identify and analysis the possible
    best-case and worst-case scenarios that would result due to
    unexpected economic, geopolitical, and technological challenges
    The best-case scenario takes into consideration what will happen
   
  </p>
  <p>
    Numerous meetings and workshops are needed to identify the
    various possible scenario and its occurrence which makes the
    process more time consuming. Due to manual process, it requires
    more resources in terms of time and investment that make the
    process costly.  unexpected economic, geopolitical.
  </p>
  <br/>
  <h3><strong> Steps to Perform Scenario Analysis</strong></h3>
  <br/>
  <ul>
    <li>
      <p>
        Identifying the key assumptions underlying our forecasts and
        clearing presenting them in a robust planning model.
      </p>
    </li>
    <li>
      <p>Developing a base case.</p>
    </li>
    <li>
      <p>
        Identifying and modeling roughly 3-7 alternative scenarios
        and estimating their likelihood.
      </p>
    </li>
    <li>
      <p>
        Monitoring the critical assumptions listed in step 1 via a
        dashboard.
      </p>
    </li>
    <li>
      <p>
        Narrowing down and refining scenarios based as events play
        out.
      </p>
    </li>
  </ul>
<br/>
  <h3><strong> Capital Budgeting with Enterprise Planning and Budgeting Cloud </strong></h3>
  <br/>
  <p>Historically Assets have been treated as an afterthought –managers pay attention only when something goes wrong. One wrong decision in terms of capital investment would prove Fatal to organization as whole. Of late Enterprises are realizing that there should be an appropriate and robust mechanism to track the Capital Investment already made, and the capital investment which is going to be made in the future.</p>
  `); // Initialize the content state
  const [postTitle, setPostTitle] = useState(`Strategic Modeling Using Oracle EPM: Long Range Planning for Uncertainties
`)

  const handleChange = (value) => {
    console.log("dfgdfgodfgoj")

    console.log("value=", value);
    // Update the content state when the editor content changes
    setContent(value);
  };
  const handleChangeTitle = (e) => {
    const { name, value } = e.target;
    setPostData({
      ...postData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    postData.content = content;

    // Use the 'content' state to save or update the post content via an API call
    // Replace this with your actual API call logic
    console.log('Saving post content:', postData);


    axios.post(apiEndpoint, postData, config)
      .then(response => {
        toast.success("Post Created Success fully")
        console.log('Post created:', response.data);
      })
      .catch(error => {
        console.error('Error creating post:', error);
      });
  };

  const navigate = useNavigate();
  const backBtn = () => {
    navigate("/searchLandingPage")
  }

  return (
    <div className="containerTable "
    // style={{ height: 'none' }}
    >
      <div className=" left-main-div column column left-column landing-left justify-content-start">
        {/* <!-- Content for the left column goes here --> */}
        <div className="logo-home others-campra-logo">
          <img src={campraImg} alt="" className='campra-log-img' />

        </div>

        <div className="repo landing text-white catagory-main-div ">
          {/* <p><strong>Knowledge Repository</strong></p> */}
          <CategoryList />
        </div>
      </div>
      <div className="column right-columnh ">
        <div className="header py-3">
          <div className="back-screen">
            <button
              type="button" className="btn " data-bs-toggle="tooltip" data-bs-placement="top" title="Home"
              onClick={backBtn}><img src={back} alt="" className='table-logo' /><p className='m-0'></p></button>
          </div>
          <div className="user-det">
            <div className="usr-bac">
              <img src={AdminImg}
                style={{ width: '50px', height: '50px' }}
                alt="" />
              <div className="user-name">
                <p id="usrname">Ronin S</p>
                <p id="usrrole">Author</p>

              </div>

            </div>


          </div>
        </div>

        <form className='container w-100 h-75 mt-4 px-5' onSubmit={handleSubmit}>

          <div className='pb-4'>
            <label htmlFor="" > Title:</label>
            <input
              onChange={handleChangeTitle}
              // value={postTitle}
              name="title"
              style={{ border: "2px dotted" }} type="text" className='w-100' />
          </div>

          <div>
            {/* <label>Edit Post Content:</label> */}
            <ReactQuill
              name="content"
              // value={content}
              onChange={handleChange}
            />
          </div>
          <div className='text-center'> <button className='btn btn-primary my-3' type="submit">Save Changes</button></div>

        </form>
        {/* <div className='container px-5'>
          <div className="main-content-post">
            <h3>
              COVID-19 Related Tracking and Reporting in Oracle HCM Cloud
            </h3>
            <p>
              Organizations need a simple and complete tool to assist with
              tracking and reporting COVID-19 related illnesses and
              vaccination statuses. In this blog, we’ll be discussing how
              Oracle HCM Cloud can support an organization with monitoring
              COVID-19 vaccination statuses for employees, how employees can
              self-report exposure or positive cases of COVID-19, and how an
              organization can report on each of these items.
            </p>
            <h3>
              How an Organization can use Oracle HCM Cloud to Monitor COVID-19
              vaccination statuses for employees in Oracle HCM Cloud
            </h3>
            <p>
              Organizations can create a simple checklist within Journeys
              (Oracle’s new tool that uses checklist tasks to enhance employee
              experiences) for new and existing employees that contains a
              questionnaire with various vaccination related questions.
              Questionnaires containing a COVID-19 Vaccine Survey can be
              included in a New Hire Journey for new employees and added to a
              Journey for existing employees. To enable a rapid deployment of
              this Journey, the existing employee population can be mass
              assigned this Journey.
            </p>
            <h3>
              How An Organization Can Report on COVID-19 Related Illnesses and
              Vaccination Statuses
            </h3>
            <p>
              Oracle HCM Cloud contains robust reporting through Business
              Intelligence. A customer favorite is the Infolet capability.
              Infolets contains a visual that represents report data in the
              form of a bar chart, graph, etc. Organizations can quickly and
              easily view high level report data at a glance. Organizations
              can create reports to easily retrieve system data from the
              COVID-19 Vaccine Survey or the COVID-19 Positive Case or
              Exposure Survey. Camptra Technologies has created custom reports
              to assist organizations with easily accessing COVID-19 related
              information.
            </p>
            <p>
              For more information about how Camptra Technologies can assist
              your organization with COVID-19 related tracking and reporting,
              reach out to us here.
            </p>
            <p>
              This information provided by your employees is secure and
              confidential. Security will be thoroughly evaluated and tested
              prior to the implementation of this process in Oracle Cloud HCM.
            </p>
          </div>
        </div> */}

      </div>


    </div>

  );
};

export default EditPostPage;
